import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Button from '@material-ui/core/Button';
/*Sign in template in : https://github.com/mui-org/material-ui/blob/master/docs/src/pages/getting-started/page-layout-examples/sign-in/SignIn.js */
// import Avatar from '@material-ui/core/Avatar';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';
//Redirect page if login
import { Redirect } from 'react-router-dom';
import logo from "../../images/transparent.png"

/*Styling */
const styles = theme => ({
  "@global":{
    body:{
      backgroundColor:"#243043"
    }
  },
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 21,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    backgroundColor:"#2B3648",
    margin:0,
    width:90,
    height:90,
    minWidth:90, 
    minHeight:90
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
   myinput: {
     root:{
        '& label.Mui-focused': {
        color: 'green',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'red',
        },
        '&:hover fieldset': {
          borderColor: 'yellow',
        },
        '&.Mui-focused fieldset': {
          borderColor: 'green',
        },
      },
     }
  },
});



export class Login extends Component {
  static propTypes = {
    login: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      usuario: { username: '', password: '' },
      showPassword: false,
      errores: {},
      formValid: false,
      openAlert:false, 
      loading:true,
    };
    this.loginContainer = React.createRef();
    this.registerContainer=React.createRef();
    this.handleChange = this.handleChange.bind(this);
  }


  doLoginOutseta=(token)=>{
    this.props.actions.checkToken(token).then(()=> {
      if(this.props.logged === true){
         this.cleanInfo();
         this.props.actions.fetchPermisos();
       }
     }).catch(() => {
       this.sendError();
     });
  }
  doLogin = () =>{
    this.props.actions.doLogin(this.state.usuario).then(()=> {
     if(this.props.logged === true){
        this.cleanInfo();
        this.props.actions.fetchPermisos();
      }
    }).catch(() => {
      this.sendError();
    });
  }

  sendError =()=>{
    this.setState({openAlert:true}); 
    this.cleanInfo();
  }
  
  cleanInfo = () => {
    let usuario = this.state.usuario;
    usuario.password = '';
    usuario.username = '';
    this.setState({
      usuario: usuario,
      errores: {},
      formValid:false
    });
  };

   handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let usuario = this.state.usuario;
    usuario[name] = value;
    this.setState({
      usuario: usuario,
    });
    this.validateForm();
  }

  validateForm = () => {
    let errores = {};
    let formValid = true;
    if (!this.state.usuario || !this.state.usuario.username || this.state.usuario.username.length < 1) {
      errores.message = 'You must introduce a valid credentials';
      formValid = false;
    }
    if (
      !this.state.usuario ||
      !this.state.usuario.password ||
      this.state.usuario.password.length < 1
    ) {
      errores.message = 'You must introduce a valid credentials';
      formValid = false;
    }
    this.setState({
      errores: errores,
      formValid: formValid,
    });
  };

  closeErrorDialog = ()=>{
    this.setState({openAlert:false});
  }

  sendToPasswordReset= ()=>{
    this.props.history.push('/login/resetPassword');
  }

  componentDidMount()
  {
    setTimeout(()=>{
      this.setState({
        loading:false
      })
    },3000)
    if(this.props.location!==undefined && this.props.location.search!==undefined){
      let query = this.props.location.search.split("=")
      if(query[0]==="?access_token"){
        this.doLoginOutseta(query[1])
      }
    }
    this.scriptLoader();
  }

  scriptLoader = () => {
    const script = document.createElement("script");
    script.src = "https://pems.outseta.com/Scripts/client/dist/outseta.auth.widget.min.js";
    script.id = "login-widget";
    script.async = true;
    script.setAttribute("data-widget-mode", "login");
    this.loginContainer.appendChild(script);
    /**adding the register widget */
    const script1 = document.createElement("script");
    script1.src = "https://pems.outseta.com/Scripts/client/dist/outseta.auth.widget.min.js";    
    script1.setAttribute("data-popup-selector", "#btnRegister");
    script1.setAttribute("data-widget-mode", "register");
    this.registerContainer.appendChild(script1);
  };


  render() {
    const { classes } = this.props;
    return (
       <main className={classes.main} >
       {localStorage.getItem("logged") ? (
          <Redirect
            push
            to={
              '/'
            }
          />
        ):null}
        <div style={{display:this.state.loading?"inlineBlock":"none", marginTop:"65%",marginLeft:"35%"}}>
            <img style={{display:"inlineBlock", verticalAlig:"middle",height:"50%", width:"50%"}} src={logo} alt="loading..."/>
            <div style={{display:"inlineBlock",marginLeft:"18%", marginTop:"5%"}}>
              <CircularProgress />
            </div>
        </div>
        <div style={{display:this.state.loading?"none":"inline"}}>
              <div style={{marginTop:"50%"}} className={classes.main} ref={el => (this.loginContainer = el)}>
              </div>
              <div style={{color:"white"}} ref={el=>(this.registerContainer =el)} >
                <Button
                id="btnRegister"
                color="inherit"
                >
                  Don't have an account yet? Create an Account
                </Button>
              </div>
        </div>
      </main>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


Login.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Login));



// WEBPACK FOOTER //
// ./src/features/login/Login.js